<template>
  <div
    class="container nav-configuration"
    ref="container"
  >
    <div class="top-wrapper">
      <nav-bg-upload v-model="backgroundImg"></nav-bg-upload>
    </div>
    <div class="remark">{{$t('management.navigate.remark_text')}}<span class="tip">{{$t('management.navigate.tip_text')}}</span>
    </div>
    <div class="bottom-wrapper">
      <div class="preview-wrapper">
        <el-tabs
          v-model="nowSchema"
          :key="navigateSchema"
        >
          <el-tab-pane name="nav-type1">
            <span slot="label">{{$t('management.navigate.nav_type1_label')}}
              <i
                class="selected"
                v-if="navigateSchema === 'nav-type1'"
              ></i></span>
          </el-tab-pane>
          <!-- <el-tab-pane name="nav-type2">
            <span slot="label">{{$t('management.navigate.nav_type2_label')}}
              <i
                class="selected"
                v-if="navigateSchema === 'nav-type2'"
              ></i></span>
          </el-tab-pane> -->
          <el-tab-pane name="nav-type3">
            <span slot="label">{{$t('management.navigate.nav_type3_label')}}
              <i
                class="selected"
                v-if="navigateSchema === 'nav-type3'"
              ></i></span>
          </el-tab-pane>
          <el-tab-pane name="nav-type4">
            <span slot="label">{{$t('management.navigate.nav_type4_label')}}
              <i
                class="selected"
                v-if="navigateSchema === 'nav-type4'"
              ></i></span>
          </el-tab-pane>
        </el-tabs>
        <div class="image-wrapper">
          <image-loader :src="previewImageSrc"></image-loader>
        </div>
      </div>
      <div class="button-wrapper">
        <el-button
          type="primary"
          @click="onSet"
        >{{$t('common.setBtn_text')}}</el-button>
        <el-button @click="onPreview">{{$t('common.previewBtn_text')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import NavBgUpload from './nav-bg-upload.vue'
import Api from 'api/api'
import ApiConfig from 'api/config'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import ImageLoader from 'components/image-loader/image-loader'
export default {
  name: 'nav-configuration',
  data () {
    return {
      backgroundImg: {
        left: {
          fileId: -1,
          path: ''
        },
        middle: {
          fileId: -1,
          path: ''
        },
        right: {
          fileId: -1,
          path: ''
        }
      },
      showOnTop: false,
      navigateSchema: 'nav-type1',
      nowSchema: ''
    }
  },
  computed: {
    previewImageSrc () {
      let urlPrefix = process.env.NODE_ENV === 'development' ? '/public' : ''
      if (this.nowSchema === 'nav-type1') {
        return `${process.env.VUE_APP_CONTEXT}${urlPrefix}/static/images/navigative_layout1.png`
      } else if (this.nowSchema === 'nav-type2') {
        return `${process.env.VUE_APP_CONTEXT}${urlPrefix}/static/images/navigative_layout2.png`
      } else if (this.nowSchema === 'nav-type3') {
        return `${process.env.VUE_APP_CONTEXT}${urlPrefix}/static/images/navigative_layout3.png`
      } else {
        return `${process.env.VUE_APP_CONTEXT}${urlPrefix}/static/images/navigative_layout4.png`
      }
    }
  },
  methods: {
    _getInfo () {
      let _loadingInstance = this._getLoading()
      Api.navigate.query().then(res => {
        _loadingInstance.close()
        this.backgroundImg = res.data.backgroundImg || this.backgroundImg
        this.showOnTop = res.data.showOnTop
        this.navigateSchema = res.data.navigateSchema || 'nav-type1'
        this.nowSchema = this.navigateSchema
      }).catch(() => {
        _loadingInstance.close()
      })
    },
    _setInfo (param) {
      let _loadingInstance = this._getLoading()
      Api.navigate.set(param).then(res => {
        _loadingInstance.close()
        this.$message.success(this.$t('management.navigate.set_success'))
      }).catch(() => {
        _loadingInstance.close()
      })
    },
    onPreview () {
      let _param = {
        backgroundImg: this.backgroundImg,
        navigateSchema: this.nowSchema,
        showOnTop: this.showOnTop
      }
      this.$storage.set('nav-info', _param)
      window.open(`${ApiConfig.context}/index?npw=true`)
    },
    onReset () {
      this._getInfo()
    },
    onSet () {
      let _param = {
        backgroundImg: {
          left: this.backgroundImg.left.fileId,
          middle: this.backgroundImg.middle.fileId,
          right: this.backgroundImg.right.fileId
        },
        showOnTop: this.showOnTop,
        navigateSchema: this.nowSchema
      }
      this.navigateSchema = this.nowSchema
      this._setInfo(_param)
    }
  },
  mounted () {
    this._getInfo()
  },
  components: {
    NavBgUpload,
    ImageLoader
  },
  mixins: [ErrorHandleMixin, LoadingMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.nav-configuration.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 32px 16px;
  position: relative;
  font-size: 12px !important;
  /deep/ .el-tabs__item {
    font-size: 12px;
  }
  .top-wrapper {
    height: 90px;
    background: url("../../../assets/images/cage.png") left top;
    border: 1px solid #ccc;
    overflow: hidden;
  }
  .remark {
    margin-top: 9px;
    color: #4c4c4c;
    .tip {
      color: #999;
    }
  }
  .bottom-wrapper {
    position: absolute;
    left: 16px;
    right: 16px;
    top: 184px;
    bottom: 16px;
    .selected {
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: middle;
      position: relative;
      top: -2px;
      background: url("../../../assets/images/icon_selected.png") center
        no-repeat;
    }
    .preview-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 68px;
      .image-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        top: 47px;
        bottom: 0;
      }
    }
    .button-wrapper {
      height: 52px;
      bottom: 0;
      left: 0;
      position: absolute;
    }
  }
}
</style>
